export const ENDERECO_PRINCIPAL_SET = "deca.ENDERECO_PRINCIPAL_SET";
